import { Container } from "@mui/system";
import React from "react";
import classes from "./Why.module.css";

const why = () => {
  return (
    <Container>
      <div className={classes.topic}>
        <h1>
          <span className={classes.why}>Why</span>
          <span className={classes.journey}>Journey</span>{" "}
          <span className={classes.analytics}>Analytics</span>
          <span className={classes.why}>?</span>
        </h1>
      </div>
      <div className={classes.contentCards}>
        <div className={classes.content1}>
          <h3>Leverage our platform to achieve the following:</h3>
          <ul>
            <li>Grow your business</li>
            <li>Manage risks with your business</li>
            <li>Improve the experience of your stakeholders</li>
            <li>Improve Loyalty</li>
          </ul>
        </div>
        <div className={classes.content2}>
          <p>
            If you landed here due to your curiosity watching the introduction
            video will be the best investment of your time. If you are here
            because we asked you to check out more about how we can help you, we
            created some useful content on the website. Once you are ready to
            talk to us, please contact us.
          </p>
          <br/>
          <br/>
          <p>
            
            If you have been here before and looking for what’s new, then check
            out our Resources page. This page will showcase the latest and
            greatest from our Engineering Team.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default why;
